const _ = require('lodash'), bannerClickAnalyticsMapper = require('./gtmmapper/banner-click-mapper');

module.exports = function (trolleyService, shelfProductService, dynamicContentService, dynamicContentCarouselService, inspirationService, gtm, $location, analyticsService) {
    return {
        restrict: 'AE',
        scope: {
            scheduleKey: '=?',
            onload: '&?',
            forceSmallFormatView: '=?',
        },
        controllerAs: 'dcCtrl',
        controller: [
            '$q', '$timeout', '$scope', '$rootScope', function ($q, $timeout, $scope, $rootScope) {
                let serverItemRequests = {};

                /**
                 * Request an item from the server. Will be resolved once all items have been requested
                 * for the layout.
                 * @param {any} id
                 * @param {any} type
                 */
                this.getServerItem = function (id, type) {
                    if (!(type in serverItemRequests)) {
                        serverItemRequests[type] = {};
                    }
                    const requestsForType = serverItemRequests[type];
                    if (!(id in requestsForType)) {
                        requestsForType[id] = $q.defer();
                    }

                    return requestsForType[id].promise;
                };

                function getRequestIds(requests) {
                    return _.reduce(requests, (result, itemRequests, itemType) => {
                        result[itemType] = _.keys(itemRequests);
                        return result;
                    }, {});
                }

                function resolveServerItemPromises(serverItems) {
                    _.forEach(serverItems, (items, type) => {
                        _.forEach(items, (item) => {
                            const idKey = type === 'Products' ? 'Stockcode' : 'ID';
                            serverItemRequests[type][item[idKey]].resolve(item);
                        });
                    });
                }

                this.onLoad = function () {
                    this.getServerItems().then(() => {
                        $timeout(() => {
                            // timeout to ensure server items have rendered
                            if ($scope.onload) {
                                $scope.onload();
                            }

                            $scope.toggleIsEmpty();
                            $scope.initCarousel();
                        }).then(() => {
                            // fire a content changed event with classes as parameters when loading is done.
                            $rootScope.$broadcast('DynamicContent:onContentChanged', $scope.getElementClasses());
                        });
                    });
                };

                /**
                 * Load all of the items which have been requested for the layout.
                 */
                this.getServerItems = function () {
                    if (!_.some(serverItemRequests)) {
                        return $q((resolve) => { resolve(); });
                    }

                    return dynamicContentService.getServerItems(getRequestIds(serverItemRequests))
                        .then(resolveServerItemPromises)
                        .finally(() => {
                            serverItemRequests = {};
                        });
                };

                this.scheduleKey = function (scheduleKey) {
                    if (scheduleKey !== undefined) {
                        $scope.scheduleKey = scheduleKey;
                    }

                    return $scope.scheduleKey;
                };
            },
        ],
        link(scope, element) {
            function getTemplateUrl(scheduleKey) {
                return scheduleKey !== null && scheduleKey !== undefined
                    ? `/Shop/DynamicContent2Panel?scheduleKey=${scheduleKey}`
                    : null;
            }

            scope.$watch('scheduleKey', (scheduleKey) => {
                scope.templateUrl = getTemplateUrl(scheduleKey);
            });

            scope.addItemToTrolley = function (stockcode, quantity, source, itemId) {
                inspirationService.setDynamicContentCardIdSessionStorage(itemId);

                shelfProductService.getProductDetail(stockcode).then((products) => {
                    if (products != null) {
                        scope.addOrUpdateItemToTrolley(products[0], quantity, source);
                    }
                });
                dynamicContentService.postMetricsClick(itemId);
            };

            scope.addOrUpdateItemToTrolley = function (product, quantity, source) {
                // Check item is in trolley. If it's update quantity.
                if (product.IsInTrolley) {
                    const addQuantity = product.QuantityInTrolley + quantity;
                    trolleyService.updateTrolleyItem(product, addQuantity);
                } else {
                    trolleyService.addItemToTrolley(product, quantity, source);
                }
            };

            scope.addMultiItemsToTrolley = function (stockcodes, source, itemId) {
                inspirationService.setDynamicContentCardIdSessionStorage(itemId);

                shelfProductService.getProductDetail(stockcodes).then((products) => {
                    if (products != null) {
                        trolleyService.addItemsToTrolley(products);
                    }
                });
                dynamicContentService.postMetricsClick(itemId);
            };

            scope.toggleIsEmpty = function () {
                const visibleItems = element.find('.dynamic-content2-item:visible');
                element.find('.dynamic-content-canvas')
                    .first()
                    .toggleClass('is-empty', visibleItems.length === 0);
            };

            scope.initCarousel = function () {
                dynamicContentCarouselService.init();
                setTimeout(() => {
                    dynamicContentCarouselService.smallFormatHomeCarouselHeight = dynamicContentCarouselService.getSmallFormatHomeCarouselHeight();
                }, 500);
            };

            scope.postMetricsClick = function (itemId, name) {
                dynamicContentService.postMetricsClick(itemId);
                gtm.push({ id: itemId, name, location: $location.path() }, bannerClickAnalyticsMapper);
                analyticsService.pushEvent(analyticsService.eventsDtm.BANNER_CLICK);
            };

            scope.setDynamicContentCardId = function (cardId) {
                inspirationService.setDynamicContentCardIdSessionStorage(cardId);
            };

            scope.getElementClasses = function () {
                return _.split(element.attr('class'), ' ');
            };

            scope.$on('window:resize', scope.toggleIsEmpty);
        },
        template: '<div class="dynamic-content2-panel" ng-include="templateUrl" onload="dcCtrl.onLoad()"></div>',
    };
};



// WEBPACK FOOTER //
// ./src/common/dynamiccontent/dynamic-content.directive.js